module.exports = __webpack_public_path__ + "img/student3.7dc02ca1.png";